import config from "config";

import instance from "../axios";

import { logoutUser, logoutWithoutLastUser } from "../users/index";

export const setToken = () => {
  localStorage.setItem("token", config.TOKEN);
  return localStorage.getItem("token");
};

export function loginUser(credentials: any) {
  return instance
    .post("v1/customer/login", credentials)
    .then((res: any) => {
      return res;
    })
    .catch((err: any) => {
      if (err.message === "Network Error") {
        return { status: 503, message: "Network Error" };
      }
      //set logged in false
      //display error
      // if (error.status === -1) {
      //   $scope.viewProps.loginError =
      //     "Login failed, please check your internet connection";
      // } else if (error.status === 401) {
      //   $scope.viewProps.loginError =
      //     "Incorrect login details. Please try again";
      // } else {
      //   $scope.viewProps.loginError = `Invalid login. Please contact ${$scope.viewProps.title} at admin@qwizard.net or 021 226 2877`;
      // }
    });
}

export function registerUser(email: string, password: string) {
  //console.log(email);
  // return createUserWithEmailAndPassword(auth, email, password)
  //   .then((userCred) => {
  //     return userCred.user;
  //   })
  //   .catch((error) => {
  //     // const errorCode = error.code;
  //     // const errorMessage = error.message;
  //     console.error(error);
  //     toast(error.message, 4000);
  //     return false;
  //   });
  return new Promise((resolve: any, reject: any) => {
    return true;
  });
}

export function getCurrentUser() {
  return new Promise((resolve, reject) => {});
}

export const logout = () => {
  return (dispatch: any) => {
    dispatch(logoutUser());
  };
};

export const logoutWithUpdate = () => {
  return (dispatch: any) => {
    dispatch(logoutWithoutLastUser());
  };
};

export const sendPasswordReset = (email: any) => {
  // return firebase.auth().sendPasswordResetEmail(email);
  // return sendPasswordResetEmail(auth, email)
  //   .then(() => {
  //     // Password reset email sent!
  //     return true;
  //   })
  //   .catch((error) => {
  //     // const errorCode = error.code;
  //     const errorMessage = error.message;
  //     console.error(errorMessage);
  //     toast(
  //       "An error occured. If problems persist, please contact a syste admin",
  //       4000
  //     );
  //     return false;
  //   });

  return new Promise((resolve: any, reject: any) => {
    return true;
  });
};
